import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

import ListAltIcon from '@mui/icons-material/ListAlt';
import { Box } from '@mui/material';

import { SCUILoadingLinear } from '../../../atomic/atoms';
import { SCUIBreadCrumb } from '../../../atomic/molecules';
import { SCUIContent } from '../../../atomic/organisms';
import { SummaryCommandV2 } from '../../../services/command';
import { PageUrl } from '../../../types/enums/pageUrl-enums';

import { SummaryListDetail, SummaryListTable } from './components';
import { SL } from './summaryList.classes';

export const SaSummaryList = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [summaryList, setSummaryList] = useState<any[]>([]);
    const [icmalDate, setIcmalDate] = useState<string>('');
    const [isSearched, setIsSearched] = useState<boolean>(false);
    const [selectedSummary, setSelectedSummary] = useState<any>(null);

    const { t } = useTranslation();

    const handleSearch = () => {
        if (!icmalDate) return;

        setIsLoading(true);
        setIsSearched(true);
        setSelectedSummary(null);

        SummaryCommandV2.GetSummaryList({
            startDate: icmalDate,
            endDate: icmalDate,
        })
            .then((res: any) => {
                const summaries = (res?.summaries || []).map((item: any) => ({
                    ...item,
                    id: item?.id,
                }));
                setSummaryList(summaries);
                setIsLoading(false);
            })
            .catch(() => {
                Swal.fire(t('general.anErrorOccured'), '', 'error');
                setIsLoading(false);
            });
    };

    const handleEdit = (row: any) => {
        setSelectedSummary(row);
    };

    return (
        <SCUIContent className={SL.page}>
            <Box className={SL.root}>
                <Box
                    className={SL.breadcrumb}
                    sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                >
                    <ListAltIcon className={SL.titleIcon} color="primary" fontSize="large" />
                    <SCUIBreadCrumb
                        onlyTitle={t('summaryAggregation.summaryList.title')}
                        components={[
                            {
                                title: t('summaryAggregation.summaryList.title'),
                                link: PageUrl.summaryAggregation.summaryList.url,
                            },
                        ]}
                    />
                </Box>
                {isLoading && (
                    <Box sx={{ margin: '24px 0' }} className={SL.loading}>
                        <SCUILoadingLinear display={isLoading} />
                    </Box>
                )}
                <SummaryListTable
                    summaryList={summaryList}
                    icmalDate={icmalDate}
                    setIcmalDate={setIcmalDate}
                    handleSearch={handleSearch}
                    isSearched={isSearched}
                    onEdit={handleEdit}
                />
                <SummaryListDetail summary={selectedSummary} />
            </Box>
        </SCUIContent>
    );
};
